<template>
  <div v-loading="loading" class="stage-detail">
    <div class="page-head">
      <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回项目计划</el-button>
      <span class="page-title">计划详情</span>
    </div>

    <el-card v-if="row" shadow="never" class="info-card">
      <div slot="header" class="card-head">
        <div class="card-title-wrap">
          <div class="card-title-row">
            <span class="card-title">{{ row.projectName || '-' }} · {{ row.stageName || '-' }}</span>
            <div class="tags">
              <el-tag size="mini" :type="statusType(stageStatusMap, row.status || 'PENDING')">
                {{ statusLabel(stageStatusMap, row.status || 'PENDING') }}
              </el-tag>
              <el-tag size="mini" :type="planScheduleLabel === '延期' ? 'warning' : 'success'">
                {{ planScheduleLabel }}
              </el-tag>
            </div>
          </div>
          <div class="card-address">{{ row.address || '-' }}</div>
        </div>
      </div>

      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="项目">
          <project-name-link :project-id="row.projectId" :name="row.projectName" />
        </el-descriptions-item>
        <el-descriptions-item label="工序">{{ row.stageName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="计划日期">
          {{ fmtRange(row.originPlanStart || row.planStart, row.originPlanEnd || row.planEnd) }}
        </el-descriptions-item>
        <el-descriptions-item label="施工日期">{{ actualPlanText }}</el-descriptions-item>
        <el-descriptions-item label="计划天数">{{ planDays }}</el-descriptions-item>
        <el-descriptions-item label="施工天数">{{ actualDays }}</el-descriptions-item>
        <el-descriptions-item label="工人">{{ row.workerName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="确认状态">{{ row.workerStatusName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="工序状态">
          <el-tag size="mini" :type="statusType(stageStatusMap, row.status || 'PENDING')">
            {{ statusLabel(stageStatusMap, row.status || 'PENDING') }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="计划状态">
          <el-tag size="mini" :type="planScheduleLabel === '延期' ? 'warning' : 'success'">
            {{ planScheduleLabel }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="排序">{{ row.sortNo != null ? row.sortNo : '-' }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { getProjectStage } from '../../api/project'
import { stageStatusMap, statusLabel, statusType } from '../../utils/status'
import ProjectNameLink from '../../components/ProjectNameLink.vue'

export default {
  name: 'ProjectStageDetail',
  components: { ProjectNameLink },
  data() {
    return {
      stageStatusMap,
      stageId: null,
      row: null,
      loading: false
    }
  },
  computed: {
    planScheduleLabel() {
      if (this.row && this.row.planScheduleStatusName) return this.row.planScheduleStatusName
      return this.planScheduleStatus(this.row)
    },
    actualPlanText() {
      return this.fmtRange(this.row && this.row.planStart, this.row && this.row.planEnd)
    },
    planDays() {
      if (!this.row) return '-'
      return this.daySpan(
        this.row.originPlanStart || this.row.planStart,
        this.row.originPlanEnd || this.row.planEnd
      )
    },
    actualDays() {
      if (!this.row) return '-'
      return this.daySpan(this.row.planStart, this.row.planEnd)
    }
  },
  created() {
    this.stageId = Number(this.$route.query.id) || null
    if (!this.stageId) {
      this.$message.warning('缺少计划参数')
      this.goBack()
      return
    }
    this.load()
  },
  methods: {
    statusLabel,
    statusType,
    goBack() {
      this.$router.push({ path: '/project/stages' })
    },
    fmtDate(v) {
      if (!v) return '-'
      const s = String(v)
      return s.length >= 10 ? s.slice(0, 10) : s
    },
    fmtRange(a, b) {
      const s = this.fmtDate(a)
      const e = this.fmtDate(b)
      if (s === '-' && e === '-') return '-'
      return s + ' ~ ' + e
    },
    daySpan(start, end) {
      const s = this.fmtDate(start)
      const e = this.fmtDate(end)
      if (s === '-' || e === '-') return '-'
      const a = new Date(s.replace(/-/g, '/'))
      const b = new Date(e.replace(/-/g, '/'))
      if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return '-'
      const days = Math.round((b - a) / 86400000) + 1
      return days > 0 ? days : '-'
    },
    planScheduleStatus(row) {
      if (!row || !row.planStart) return '正常'
      const constructionStart = this.fmtDate(row.planStart)
      const planStart = this.fmtDate(row.originPlanStart || row.planStart)
      if (constructionStart === '-' || planStart === '-') return '正常'
      return constructionStart > planStart ? '延期' : '正常'
    },
    async load() {
      this.loading = true
      try {
        const res = await getProjectStage(this.stageId)
        this.row = res.data || null
        if (!this.row) {
          this.$message.warning('计划不存在')
          this.goBack()
        }
      } catch (e) {
        this.goBack()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.stage-detail { max-width: 920px; }
.page-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.page-title { font-size: 16px; font-weight: 600; color: #1f2d3d; }
.info-card { border-radius: 4px; }
.card-head { padding: 0; }
.card-title-wrap { width: 100%; }
.card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.card-title { font-weight: 600; color: #1f2d3d; }
.card-address {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
}
.tags { display: flex; gap: 8px; }
</style>
